import { createContext, useContext } from 'react'

interface DrawerNavigationContextType {
    updateNavList: () => void
}

export const DrawerNavigationContext = createContext<DrawerNavigationContextType>({
    updateNavList: () => { /** */ }
})
